<template>
    <div>
        <a href="https://iouu.com.br" target="_blank" class="logo"><img src="../assets/images/logo-light.svg" alt="logo IOUU"></a>
        <div class="image">
            <img class="imagem" src="../assets/images/img-login.png" alt="imagem login">
            <div class="box">
                <img src="../assets/images/icon-gif.svg" alt="icone">

                <div class="text">
                    <p class="txt">{{titleBox}}</p>
                    <p class="txt">{{subtitleBox}}</p>
                    <p>{{txtBox}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        titleBox: 'Rápido. Simples.',
        subtitleBox:'Bom para você e para o mundo.',
        txtBox:'Retornos de até 58,27% ao ano.'
        }
    }
}
</script>

<style lang="scss" scoped>
$verde: #41D3BD;
$azul: #21247F;
$azul-sec:  #3B46C4;
$branco: #ffffff;
$cinza-claro: #E9EAFA;
$cinza-medio: #818495;
$cinza-escuro: #2C3236;

* {
    color: $cinza-medio;
    font-size: 1rem;
    list-style: none;
    text-decoration: none;
    margin: 0;
    padding: 0;
    text-align: left;
    border: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    font-size: 1rem;
    // font-family: 'Inter';
    line-height: 170%;
    letter-spacing: 0.01em;
}

.image {
    position: relative;
    width: 772px;
    height: 682px;
    left: -185px;
    .imagem {
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .box {
        padding: 25px 56px 27px;
        position: absolute;
        right: 36px;
        bottom: 95px;
        background-color: $branco;
        border-radius: 8px;
        width: 436px;
        height: 139px;
        display: flex;
        align-items: flex-start;
        img {
            margin-right: 21px;
        }
        p {
            margin-bottom: 0;
        }
        .txt {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-weight: bold;
            font-size: 1.125rem;
            line-height: 135%;
            letter-spacing: 0.005em;
            color: $cinza-escuro;
            &:first-child {
                color: $verde;
            }
            &:last-child {
                color: $azul;
            }
        }
    }

    &:after {
        content: "";
        position: absolute;
        background: url(../assets/images/after-login.svg) no-repeat;
        background-size: cover;
        width: 570px;
        height: 270px;
        bottom: -180px;
        left: 140px;
    }
}

.logo {
    position: absolute;
    top: 42px;
    left: 180px;
    z-index: 3;
    left: 15px;
}

@media (max-width: 1440px) {

    .image{
        left: -100px;
    }
}

@media (max-width: 1336px) {
    .image{
        left: -80px;
    }
}

@media (max-width: 1050px) {
    .logo {
        display: none;
    }
    .image {
        display: none;
    }

}

</style>


// WEBPACK FOOTER //
// src/components/RegistrationScreenBanner.vue